import { useProjects } from '@/features/end-of-lease/api';
import { IataBinderDashboard } from '@/features/iata-binder/IataBinderDashboard';
import { createFileRoute } from '@tanstack/react-router';

import { validateFilterSearch } from '@/lib/filterSearchParams';

export const Route = createFileRoute('/iata-binder/')({
    component: IataBinderPage,
    validateSearch: validateFilterSearch,
});

const DEMO_PROJECT_TITLES = [
    // preprod
    'A123456 Documents',

    // staging
    'Singapore Airlines 9V-SGA Airbus A350-941',

    // local
    'Delivery of A320-214 MSN: 05047'
]

function IataBinderPage() {
    const { data: projects } = useProjects({});

    const demoProjects = projects?.filter(project => DEMO_PROJECT_TITLES.includes(project.title)) || [];

    return <IataBinderDashboard projects={demoProjects} />;
}
